import AllResults from "pages/PanelPage/components/selectedAssessment/assessmentResults/AllResults/AllResults";

export default AllResults;
